/* oxlint-disable no-inner-declarations */
import { ok } from '@oazapfts/runtime';
import * as rq from '@tanstack/react-query';

import type { TaskUser } from '@/task-manager/entities/task-user';

import { type BodyOf, usersV1NewUpdate } from '../fetch-client';
import { taskUserMapper } from '../mappers/task-user';
import { ListUsers } from '../queries/list-users';
import { useFetchOpts } from '../use-fetch-opts';

export namespace CreateUser {
  export type Input = {
    name: string;
    email: string;
    company: string;
  };

  export type Output = TaskUser;

  function bodyFromInput(input: Input): BodyOf<typeof usersV1NewUpdate> {
    return {
      createUserInputRequest: {
        name: input.name,
        email: input.email,
        company: input.company,
      },
    };
  }

  export function useMutation() {
    const getOpts = useFetchOpts();
    const queryClient = rq.useQueryClient();

    return rq.useMutation<Output, unknown, Input>({
      async mutationFn(input) {
        const opts = await getOpts();
        const body = bodyFromInput(input);
        const user = await ok(usersV1NewUpdate(body, opts));
        return taskUserMapper(user);
      },
      async onSuccess() {
        await queryClient.invalidateQueries({
          queryKey: ListUsers.key(),
        });
      },
    });
  }
}
